// Base layout elements schema from vertical base
import { baseLayoutElementsSchema } from 'ctm-vertical-base';

// layout elements
import bodyJourney from './body_journey.json';
import bodyRegoLookup from './body_rego_lookup.json';
import bodyResults from './body_results.json';
import bodyCallOptions from './body_call_options.json';
import bodyMoreInfo from './body_more_info.json';
import header from './header.json';
import footer from './footer.json';

// Main mapping
import layoutMappingSchema from './main.json';

const layoutElementsSchema = {
    ...baseLayoutElementsSchema,
    ...bodyJourney,
    ...bodyRegoLookup,
    ...bodyResults,
    ...bodyCallOptions,
    ...bodyMoreInfo,
    ...header,
    ...footer
};

export default { layoutMappingSchema, layoutElementsSchema };
